export const LOCALES = {
    default: {
        language: '',
        client: '',
        site: '',
        country: '',
    },
    'en-us': {
        language: 'eng',
        client: 'fpro-us',
        site: 'pro.ford.com',
        country: 'us',
    },
    'en-ca': {
        language: 'eng',
        client: 'fpro-can',
        site: 'pro.ford.ca',
        country: 'ca',
    },
    'fr-ca': {
        language: 'fre',
        client: 'fpro-can',
        site: 'pro.ford.ca',
        country: 'ca',
    },
    'nl-nl': {
        language: 'dut',
        client: 'ford-nl',
        site: 'ford-pro',
        country: 'ford-nl',
    },
    'en-nl': {
        language: 'eng',
        client: 'ford-nl',
        site: 'ford-pro',
        country: 'ford-nl',
    },
    'en-gb': {
        language: 'eng',
        client: 'ford-gb',
        site: 'ford-pro',
        country: 'ford-gb',
    },
    'fr-fr': {
        language: 'fra',
        client: 'ford-fr',
        site: 'ford-pro',
        country: 'ford-fr',
    },
    'it-it': {
        language: 'ita',
        client: 'ford-it',
        site: 'ford-pro',
        country: 'ford-it',
    },
    'es-es': {
        language: 'spa',
        client: 'ford-es',
        site: 'ford-pro',
        country: 'ford-es',
    },
    'de-de': {
        language: 'deu',
        client: 'ford-de',
        site: 'ford-pro',
        country: 'ford-de',
    },
    'no-no': {
        language: 'nor',
        client: 'ford-no',
        site: 'ford-pro',
        country: 'ford-no',
    },
};
